import { render, staticRenderFns } from "./UkrTreasuresEditingUser.vue?vue&type=template&id=d6d594ac&scoped=true"
import script from "./UkrTreasuresEditingUser.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresEditingUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d594ac",
  null
  
)

export default component.exports